import {Component} from '@angular/core';
import {WatchService} from '../../../pages/watch/services/watch.service';
import {AppMessageService} from '../../services/app-message/app-message.service';
import {AuthService} from '../../services/auth/auth.service';
import {FileApiService} from '../../services/file-api/file-api.service';

export interface CaseTeamMember {
  fullname: string;
  id: number;
  watchRole: string;
  photo: string;
  contacts: { id: number; phone: string; prefixValue: string }[];
  contact: { id: number; phone: string; prefixValue: string };
  isCome: boolean;
}

@Component({
  selector: 'app-watch-team-members-card',
  templateUrl: './watch-team-members-card.component.html',
  styleUrl: './watch-team-members-card.component.scss',
})
export class WatchTeamMembersCardComponent {
  teamMembers: CaseTeamMember[] = [];
  showTeamMembers: boolean = false;
  dotName: string = '';
  token: string;

  constructor(
    private readonly watchService: WatchService,
    private readonly messageService: AppMessageService,
    private readonly authService: AuthService,
    private readonly fileService: FileApiService
  ) {
    this.token = this.authService.getToken() ?? '';
  }

  async initilize(
    dotName: string,
    filter: {
      startDate?: Date;
      endDate?: Date;
      vehicleId?: number;
      dotId?: number;
    },
    teamMembers?: CaseTeamMember[]
  ) {
    this.dotName = dotName;

    // o statü tarihleri arasında nöbette olan çalışanlar tespit ediliyor
    if (teamMembers && teamMembers?.length > 0) {
      this.teamMembers = teamMembers;
      this.showTeamMembers = true;
      await Promise.all(
        this.teamMembers.map(async (item) => {
          try {
            if (item?.photo && this.token) {
              const safeUrl = await this.fileService.getFileSafeUrl(
                item.photo,
                this.token
              );
              item.photo = safeUrl as any;
            }
          } catch (e) {
            console.error(e)
          }
        })
      );
    } else {
      this.watchService
        .getWatchStaff({
          dotId: filter?.dotId,
          vehicleId: filter?.vehicleId,
          startDate: filter?.startDate,
          endDate: filter?.endDate,
        })
        .subscribe({
          next: (res) => {
            if (res.success) {

              this.teamMembers = res?.staffs ?? [];

              if (this.teamMembers.length === 0) {
                this.messageService.warningToast(
                  'Personel Bulunamadı',
                  'Hiçbir personel bulunamadı'
                );
                return;
              }

              this.showTeamMembers = true;

              void (async () => {
                await Promise.all(
                  this.teamMembers.map(async (item) => {
                    try {
                      if (item?.photo && this.token) {
                        const safeUrl = await this.fileService.getFileSafeUrl(
                          item.photo,
                          this.token
                        );
                        item.photo = safeUrl as any;
                      }
                    } catch {
                    }
                  })
                );
              })();
            }
          },
        });

    }
  }

  teamInfoClose() {
    this.teamMembers = [];
    this.dotName = '';
  }
}
